import { FONTS } from '../../../../constants/fonts';
import {
    ptFactor,
    SIZE_OPTIONS, sizeScale, textWidthDp, textWidthMb, textWidthPt
} from '../../../../constants/sizes';

const lpTextFontSize = 29 * sizeScale;
const ptTextFontSize = 24 * sizeScale * ptFactor;
const mbTextFontSize = 36 * sizeScale * ptFactor;

export const getTextMetrics = (orientation) => {
    const base = {
        fontFamily: FONTS.REGULAR,
        letterSpacing: 3 / 29,
        isUpperCase: true,
        lineHeight: 1
    };

    if (orientation === SIZE_OPTIONS.LANDSCAPE) {
        return {
            ...base,
            fontSize: lpTextFontSize,
            width: textWidthDp
        };
    }

    if (orientation === SIZE_OPTIONS.PORTRAIT) {
        return {
            ...base,
            fontSize: ptTextFontSize,
            width: textWidthPt
        };
    }

    if (orientation === SIZE_OPTIONS.MOBILE_LANDSCAPE) {
        return {
            ...base,
            fontSize: ptTextFontSize * 1.3,
            width: textWidthMb
        };
    }

    return {
        ...base,
        fontSize: mbTextFontSize,
        width: textWidthMb
    };
};
